/* eslint-disable */
export default {
  infoMessageMins:
    'Guardar automaticamente o início de sessão dentro de {delayTime} minutos…',
  infoMessageMin:
    'Guardar automaticamente o início de sessão dentro de {delayTime} minuto…',
  infoMessageSecs:
    'Guardar automaticamente o início de sessão dentro de {delayTime} segundos…',
  infoMessageSec:
    'Guardar automaticamente o início de sessão dentro de {delayTime} segundo…',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
